/*
 * $Id:: ConfirmUpdateDialog.js 2021/01/21 11:32 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';

import { t } from '../../../../providers';

const useStyles = makeStyles((theme) => ({
    dialogOverride: {
        padding: '20px',
        color: 'black',
    },
    email: {
        color: theme.palette.text.mainBlue,
    },
}));

const ConfirmUpdateDialog = ({ open, onAccept, onCancel, ipoName }) => {
    const classes = useStyles();
    return (
        <Dialog open={open} onClose={onAccept} aria-labelledby="reset-account-accept-dialog" className={classes.dialogOverride}>
            <DialogTitle id="form-dialog-title">{t('important.notice')}</DialogTitle>
            <DialogContent>
                <DialogContentText>{t('update.details.confirm.description', { ipoName })}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={onCancel}>
                    {t('back')}
                </Button>
                <Button variant="outlined" onClick={onAccept}>
                    {t('ok').toUpperCase()}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmUpdateDialog;
